/* tslint:disable */
/* eslint-disable */
/**
 * Bonds API
 * Microservice backend for bond management
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import dayjs from 'dayjs';
import type {
  Consent,
  CreateConsent,
  PatchedProfile,
  Profile,
  ProfileIssue,
  ProfileSync,
} from '../models/index';
import {
    ConsentFromJSON,
    ConsentToJSON,
    CreateConsentFromJSON,
    CreateConsentToJSON,
    PatchedProfileFromJSON,
    PatchedProfileToJSON,
    ProfileFromJSON,
    ProfileToJSON,
    ProfileIssueFromJSON,
    ProfileIssueToJSON,
    ProfileSyncFromJSON,
    ProfileSyncToJSON,
} from '../models/index';

export interface CreateProfileConsentRequest {
    xCFGINVESTORUSERID: string;
    createConsent: CreateConsent;
}

export interface DeleteProfileConsentRequest {
    xCFGINVESTORUSERID: string;
    id: number;
}

export interface GetInvestorProfileRequest {
    xCFGINVESTORUSERID: string;
}

export interface GetInvestorProfileIssuesRequest {
    xCFGINVESTORUSERID: string;
}

export interface ListInvestorProfileBondsIssuesRequest {
    xCFGINVESTORUSERID: string;
}

export interface ListProfileConsentsRequest {
    xCFGINVESTORUSERID: string;
}

export interface PartialUpdateInvestorProfileRequest {
    xCFGINVESTORUSERID: string;
    patchedProfile?: PatchedProfile;
}

export interface SyncBondsOrdersRequest {
    xCFGINVESTORUSERID: string;
    profileSync?: ProfileSync;
}

export interface UpdateInvestorProfileRequest {
    xCFGINVESTORUSERID: string;
    profile: Profile;
}

export interface VerifyInvestorProfileRequest {
    xCFGINVESTORUSERID: string;
}

/**
 * 
 */
export class InvestorProfileApi extends runtime.BaseAPI {

    /**
     */
    async createProfileConsentRaw(requestParameters: CreateProfileConsentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Consent>> {
        if (requestParameters['xCFGINVESTORUSERID'] == null) {
            throw new runtime.RequiredError(
                'xCFGINVESTORUSERID',
                'Required parameter "xCFGINVESTORUSERID" was null or undefined when calling createProfileConsent().'
            );
        }

        if (requestParameters['createConsent'] == null) {
            throw new runtime.RequiredError(
                'createConsent',
                'Required parameter "createConsent" was null or undefined when calling createProfileConsent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCFGINVESTORUSERID'] != null) {
            headerParameters['X-CFG-INVESTOR-USER-ID'] = String(requestParameters['xCFGINVESTORUSERID']);
        }

        const response = await this.request({
            path: `/api/investors/v1/profile/consents/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateConsentToJSON(requestParameters['createConsent']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConsentFromJSON(jsonValue));
    }

    /**
     */
    async createProfileConsent(requestParameters: CreateProfileConsentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Consent> {
        const response = await this.createProfileConsentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteProfileConsentRaw(requestParameters: DeleteProfileConsentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['xCFGINVESTORUSERID'] == null) {
            throw new runtime.RequiredError(
                'xCFGINVESTORUSERID',
                'Required parameter "xCFGINVESTORUSERID" was null or undefined when calling deleteProfileConsent().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteProfileConsent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCFGINVESTORUSERID'] != null) {
            headerParameters['X-CFG-INVESTOR-USER-ID'] = String(requestParameters['xCFGINVESTORUSERID']);
        }

        const response = await this.request({
            path: `/api/investors/v1/profile/consents/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteProfileConsent(requestParameters: DeleteProfileConsentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteProfileConsentRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getInvestorProfileRaw(requestParameters: GetInvestorProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Profile>> {
        if (requestParameters['xCFGINVESTORUSERID'] == null) {
            throw new runtime.RequiredError(
                'xCFGINVESTORUSERID',
                'Required parameter "xCFGINVESTORUSERID" was null or undefined when calling getInvestorProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCFGINVESTORUSERID'] != null) {
            headerParameters['X-CFG-INVESTOR-USER-ID'] = String(requestParameters['xCFGINVESTORUSERID']);
        }

        const response = await this.request({
            path: `/api/investors/v1/profile/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileFromJSON(jsonValue));
    }

    /**
     */
    async getInvestorProfile(requestParameters: GetInvestorProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Profile> {
        const response = await this.getInvestorProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getInvestorProfileIssuesRaw(requestParameters: GetInvestorProfileIssuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProfileIssue>>> {
        if (requestParameters['xCFGINVESTORUSERID'] == null) {
            throw new runtime.RequiredError(
                'xCFGINVESTORUSERID',
                'Required parameter "xCFGINVESTORUSERID" was null or undefined when calling getInvestorProfileIssues().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCFGINVESTORUSERID'] != null) {
            headerParameters['X-CFG-INVESTOR-USER-ID'] = String(requestParameters['xCFGINVESTORUSERID']);
        }

        const response = await this.request({
            path: `/api/investors/v1/profile/issues/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProfileIssueFromJSON));
    }

    /**
     */
    async getInvestorProfileIssues(requestParameters: GetInvestorProfileIssuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProfileIssue>> {
        const response = await this.getInvestorProfileIssuesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listInvestorProfileBondsIssuesRaw(requestParameters: ListInvestorProfileBondsIssuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProfileIssue>>> {
        if (requestParameters['xCFGINVESTORUSERID'] == null) {
            throw new runtime.RequiredError(
                'xCFGINVESTORUSERID',
                'Required parameter "xCFGINVESTORUSERID" was null or undefined when calling listInvestorProfileBondsIssues().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCFGINVESTORUSERID'] != null) {
            headerParameters['X-CFG-INVESTOR-USER-ID'] = String(requestParameters['xCFGINVESTORUSERID']);
        }

        const response = await this.request({
            path: `/api/investors/v1/profile/bonds-issues/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProfileIssueFromJSON));
    }

    /**
     */
    async listInvestorProfileBondsIssues(requestParameters: ListInvestorProfileBondsIssuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProfileIssue>> {
        const response = await this.listInvestorProfileBondsIssuesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listProfileConsentsRaw(requestParameters: ListProfileConsentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Consent>>> {
        if (requestParameters['xCFGINVESTORUSERID'] == null) {
            throw new runtime.RequiredError(
                'xCFGINVESTORUSERID',
                'Required parameter "xCFGINVESTORUSERID" was null or undefined when calling listProfileConsents().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCFGINVESTORUSERID'] != null) {
            headerParameters['X-CFG-INVESTOR-USER-ID'] = String(requestParameters['xCFGINVESTORUSERID']);
        }

        const response = await this.request({
            path: `/api/investors/v1/profile/consents/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ConsentFromJSON));
    }

    /**
     */
    async listProfileConsents(requestParameters: ListProfileConsentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Consent>> {
        const response = await this.listProfileConsentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partialUpdateInvestorProfileRaw(requestParameters: PartialUpdateInvestorProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Profile>> {
        if (requestParameters['xCFGINVESTORUSERID'] == null) {
            throw new runtime.RequiredError(
                'xCFGINVESTORUSERID',
                'Required parameter "xCFGINVESTORUSERID" was null or undefined when calling partialUpdateInvestorProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCFGINVESTORUSERID'] != null) {
            headerParameters['X-CFG-INVESTOR-USER-ID'] = String(requestParameters['xCFGINVESTORUSERID']);
        }

        const response = await this.request({
            path: `/api/investors/v1/profile/`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedProfileToJSON(requestParameters['patchedProfile']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileFromJSON(jsonValue));
    }

    /**
     */
    async partialUpdateInvestorProfile(requestParameters: PartialUpdateInvestorProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Profile> {
        const response = await this.partialUpdateInvestorProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async syncBondsOrdersRaw(requestParameters: SyncBondsOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Profile>> {
        if (requestParameters['xCFGINVESTORUSERID'] == null) {
            throw new runtime.RequiredError(
                'xCFGINVESTORUSERID',
                'Required parameter "xCFGINVESTORUSERID" was null or undefined when calling syncBondsOrders().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCFGINVESTORUSERID'] != null) {
            headerParameters['X-CFG-INVESTOR-USER-ID'] = String(requestParameters['xCFGINVESTORUSERID']);
        }

        const response = await this.request({
            path: `/api/investors/v1/profile/sync-bonds-orders/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProfileSyncToJSON(requestParameters['profileSync']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileFromJSON(jsonValue));
    }

    /**
     */
    async syncBondsOrders(requestParameters: SyncBondsOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Profile> {
        const response = await this.syncBondsOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateInvestorProfileRaw(requestParameters: UpdateInvestorProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Profile>> {
        if (requestParameters['xCFGINVESTORUSERID'] == null) {
            throw new runtime.RequiredError(
                'xCFGINVESTORUSERID',
                'Required parameter "xCFGINVESTORUSERID" was null or undefined when calling updateInvestorProfile().'
            );
        }

        if (requestParameters['profile'] == null) {
            throw new runtime.RequiredError(
                'profile',
                'Required parameter "profile" was null or undefined when calling updateInvestorProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCFGINVESTORUSERID'] != null) {
            headerParameters['X-CFG-INVESTOR-USER-ID'] = String(requestParameters['xCFGINVESTORUSERID']);
        }

        const response = await this.request({
            path: `/api/investors/v1/profile/`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProfileToJSON(requestParameters['profile']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileFromJSON(jsonValue));
    }

    /**
     */
    async updateInvestorProfile(requestParameters: UpdateInvestorProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Profile> {
        const response = await this.updateInvestorProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async verifyInvestorProfileRaw(requestParameters: VerifyInvestorProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['xCFGINVESTORUSERID'] == null) {
            throw new runtime.RequiredError(
                'xCFGINVESTORUSERID',
                'Required parameter "xCFGINVESTORUSERID" was null or undefined when calling verifyInvestorProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCFGINVESTORUSERID'] != null) {
            headerParameters['X-CFG-INVESTOR-USER-ID'] = String(requestParameters['xCFGINVESTORUSERID']);
        }

        const response = await this.request({
            path: `/api/investors/v1/profile/verify/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async verifyInvestorProfile(requestParameters: VerifyInvestorProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.verifyInvestorProfileRaw(requestParameters, initOverrides);
    }

}
